var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { useIntl } from "react-intl";
import { Datepicker } from "@folio/stripes/components";
import { HelpTooltip } from "./HelpTooltip";
import styles from "./RecekInput.module.css";
import { useHelpTooltip } from "../../hooks/useHelpTooltip";
export var RecekDatepicker = forwardRef(function (_a, ref) {
    var labelId = _a.labelId, _b = _a.showLabel, showLabel = _b === void 0 ? true : _b, _c = _a.highlight, highlight = _c === void 0 ? false : _c, rest = __rest(_a, ["labelId", "showLabel", "highlight"]);
    var formatMessage = useIntl().formatMessage;
    var _d = useHelpTooltip(labelId), helpId = _d.helpId, hasHelp = _d.hasHelp;
    var wrapperRef = useRef(null);
    useImperativeHandle(ref, function () { return ({
        focus: function () {
            var _a;
            var input = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("input");
            input === null || input === void 0 ? void 0 : input.focus();
        },
    }); });
    return (React.createElement("div", { ref: wrapperRef, className: "".concat(styles.wrapper, " ").concat(highlight ? styles.highlight : "") },
        React.createElement(Datepicker, __assign({}, rest, { label: showLabel ? formatMessage({ id: labelId }) : undefined })),
        hasHelp && (React.createElement(HelpTooltip, { id: "".concat(labelId, "-help"), textId: helpId, hasLabel: showLabel }))));
});
